import {
  CheckCircle,
  InfoCircle,
  RefreshDouble,
  WarningTriangle,
  Xmark,
  XmarkCircle,
} from 'iconoir-react';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    className='toaster group pointer-events-none'
    closeButton={true}
    icons={{
      success: <CheckCircle className='size-4' />,
      info: <InfoCircle className='size-4' />,
      warning: <WarningTriangle className='size-4' />,
      error: <XmarkCircle className='size-4' />,
      loading: <RefreshDouble className='size-4 animate-spin' />,
      close: <Xmark className='size-3.5' />,
    }}
    offset={100}
    style={
      {
        '--normal-bg': 'color-mix(in srgb, var(--background) 55%, transparent)',
        '--normal-text': 'var(--foreground)',
        '--normal-border': 'color-mix(in srgb, var(--border) 80%, transparent)',
        '--border-radius': '22px',
      } as React.CSSProperties
    }
    theme='light'
    toastOptions={{
      classNames: {
        toast:
          'group toast pointer-events-auto isolate gap-3! overflow-hidden rounded-[22px]! border-border/80! bg-background/55! py-3.5! pr-10! pl-4! font-[var(--v2-font)] text-[13px]! leading-[1.4]! text-foreground! shadow-2xl! backdrop-blur-[28px]! backdrop-saturate-[1.8]! before:pointer-events-none before:absolute before:inset-0 before:-z-10 before:rounded-[inherit] before:bg-linear-to-br before:from-background/80 before:via-background/20 before:to-transparent before:content-["_"]',
        content: 'pt-1!',
        title: 'font-medium! tracking-[-0.005em]! whitespace-pre-line!',
        description: 'text-muted-foreground!',
        icon: 'toast-icon m-0! flex! size-7! shrink-0! items-center! justify-center! text-foreground!',
        success: '[&_.toast-icon]:text-primary!',
        error: '[&_.toast-icon]:text-destructive!',
        actionButton: 'rounded-full bg-primary text-primary-foreground',
        cancelButton: 'rounded-full bg-muted text-muted-foreground',
        closeButton:
          'absolute! top-2.5! right-2.5! left-auto! size-6! translate-x-0! translate-y-0! rounded-full! border-border/80! bg-foreground/6! text-foreground! opacity-100! shadow-inner! transition-colors [@media(hover:hover)]:opacity-0! group-hover:opacity-100! hover:bg-accent! hover:text-accent-foreground! focus:opacity-100!',
      },
    }}
    {...props}
  />
);

export { Toaster };
